/* ════════════ THE COUNTDOWN ════════════
   The now page's atmosphere: clocks scattered in the dark, all
   ticking down. When one hits zero it flashes and another starts
   somewhere else. None of them were ever going to wait for you. */

import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function countdown(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#clock")!;
  const ctx = c.getContext("2d")!;

  const RED = "#ff4530";
  const GREY = "#9aa0a6";

  type Timer = {
    x: number;
    y: number;
    secs: number; // remaining
    frames: number; // frame accumulator for 1s ticks
    flash: number; // frames of 00:00 flash left
    size: number;
    col: string;
  };
  let timers: Timer[] = [];

  const spawn = (): Timer => {
    const isHot = Math.random() < 0.18;
    return {
      x: Math.random() * c.width,
      y: Math.random() * c.height,
      secs: 10 + ((Math.random() * 290) | 0),
      frames: (Math.random() * 60) | 0, // desync
      flash: 0,
      size: isHot ? 13 + Math.random() * 6 : 10 + Math.random() * 4,
      col: isHot ? RED : GREY,
    };
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(34, Math.floor((c.width * c.height) / 52000));
    timers = Array.from({ length: count }, spawn);
  };
  seed();
  addEventListener("resize", seed, { signal });

  const fmt = (s: number) =>
    `${String((s / 60) | 0).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const t of timers) {
      const hot = t.col === RED;
      if (t.flash > 0) {
        // 00:00 — blink red regardless of color, then respawn elsewhere
        ctx.globalAlpha = (t.flash % 20 < 10 ? 0.65 : 0.15);
        ctx.fillStyle = RED;
      } else {
        ctx.globalAlpha = hot ? 0.45 : 0.18;
        ctx.fillStyle = t.col;
      }
      ctx.font = `${t.size}px "IBM Plex Mono", monospace`;
      ctx.fillText(t.flash > 0 ? "00:00" : fmt(t.secs), t.x, t.y);
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (let i = 0; i < timers.length; i++) {
      const t = timers[i]!;
      if (t.flash > 0) {
        t.flash--;
        if (t.flash === 0) timers[i] = spawn();
        continue;
      }
      if (++t.frames >= 60) {
        t.frames = 0;
        if (--t.secs <= 0) t.flash = 80;
      }
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage(countdown);
